<div class="UserReplies">
  <div class="ContactsListing-header">
    <div class="Breadcrumbs">
      <div class="Breadcrumbs-items">
        <a [routerLink]="['/contents']"
          ><mat-icon class="Breadcrumbs-icon back"
            >keyboard_backspace</mat-icon
          ></a
        >
        <span class="Breadcrumbs-item">Response Group</span>
      </div>
    </div>
  </div>
  <div class="UserReplies-body d-flex flex-column pt-5 pb-3">
    <div class="UserReplies-body-item flex-grow-1 d-flex flex-row">
      <div
        class="UserReplies-body-item-text flex-grow-1 d-flex align-items-center">
        <h5>Meeting</h5>
      </div>
      <div class="UserReplies-body-item-button flex-grow-0">
        <app-button
          [style]="buttonProperties.style"
          [color]="buttonProperties.color"
          [size]="buttonProperties.size"
          [text]="buttonProperties.text"
          [route]="getButtonRoute('meeting')"></app-button>
      </div>
    </div>
    <div class="UserReplies-body-item flex-grow-1 d-flex flex-row">
      <div
        class="UserReplies-body-item-text flex-grow-1 d-flex align-items-center">
        <h5>Follow Up Immediate Email</h5>
      </div>
      <div class="UserReplies-body-item-button flex-grow-0">
        <app-button
          [style]="buttonProperties.style"
          [color]="buttonProperties.color"
          [size]="buttonProperties.size"
          [text]="buttonProperties.text"
          [route]="getButtonRoute('followup')"></app-button>
      </div>
    </div>
    <div class="UserReplies-body-item flex-grow-1 d-flex flex-row">
      <div
        class="UserReplies-body-item-text flex-grow-1 d-flex align-items-center">
        <h5>Follow Up Future Email</h5>
      </div>
      <div class="UserReplies-body-item-button flex-grow-0">
        <app-button
          [style]="buttonProperties.style"
          [color]="buttonProperties.color"
          [size]="buttonProperties.size"
          [text]="buttonProperties.text"
          [route]="getButtonRoute('followup-future')"></app-button>
      </div>
    </div>
    <div class="UserReplies-body-item flex-grow-1 d-flex flex-row">
      <div
        class="UserReplies-body-item-text flex-grow-1 d-flex align-items-center">
        <h5>Follow Up Cycle Email</h5>
      </div>
      <div class="UserReplies-body-item-button flex-grow-0">
        <app-button
          [style]="buttonProperties.style"
          [color]="buttonProperties.color"
          [size]="buttonProperties.size"
          [text]="buttonProperties.text"
          [route]="getButtonRoute('followup-cycle')"></app-button>
      </div>
    </div>
    <div class="UserReplies-body-item flex-grow-1 d-flex flex-row">
      <div
        class="UserReplies-body-item-text flex-grow-1 d-flex align-items-center">
        <h5>Cycle Immediate Email</h5>
      </div>
      <div class="UserReplies-body-item-button flex-grow-0">
        <app-button
          [style]="buttonProperties.style"
          [color]="buttonProperties.color"
          [size]="buttonProperties.size"
          [text]="buttonProperties.text"
          [route]="getButtonRoute('cycle')"></app-button>
      </div>
    </div>
    <div class="UserReplies-body-item flex-grow-1 d-flex flex-row">
      <div
        class="UserReplies-body-item-text flex-grow-1 d-flex align-items-center">
        <h5>Cycle Future Email</h5>
      </div>
      <div class="UserReplies-body-item-button flex-grow-0">
        <app-button
          [style]="buttonProperties.style"
          [color]="buttonProperties.color"
          [size]="buttonProperties.size"
          [text]="buttonProperties.text"
          [route]="getButtonRoute('cycle-future')"></app-button>
      </div>
    </div>
    <div class="UserReplies-body-item flex-grow-1 d-flex flex-row">
      <div
        class="UserReplies-body-item-text flex-grow-1 d-flex align-items-center">
        <h5>Inactive</h5>
      </div>
      <div class="UserReplies-body-item-button flex-grow-0">
        <app-button
          [style]="buttonProperties.style"
          [color]="buttonProperties.color"
          [size]="buttonProperties.size"
          [text]="buttonProperties.text"
          [route]="getButtonRoute('inactive')"></app-button>
      </div>
    </div>
    <div class="UserReplies-body-item flex-grow-1 d-flex flex-row">
      <div
        class="UserReplies-body-item-text flex-grow-1 d-flex align-items-center">
        <h5>Remove</h5>
      </div>
      <div class="UserReplies-body-item-button flex-grow-0">
        <app-button
          [style]="buttonProperties.style"
          [color]="buttonProperties.color"
          [size]="buttonProperties.size"
          [text]="buttonProperties.text"
          [route]="getButtonRoute('remove')"></app-button>
      </div>
    </div>
    <div class="UserReplies-body-item flex-grow-1 d-flex flex-row">
      <div
        class="UserReplies-body-item-text flex-grow-1 d-flex align-items-center">
        <h5>Vip Left Message</h5>
      </div>
      <div class="UserReplies-body-item-button flex-grow-0">
        <app-button
          [style]="buttonProperties.style"
          [color]="buttonProperties.color"
          [size]="buttonProperties.size"
          [text]="buttonProperties.text"
          [route]="getButtonRoute('vip-message')"></app-button>
      </div>
    </div>
  </div>
</div>
